export const SECTION_TYPES = Object.freeze({
    empty: 'empty',
    tabs: 'tabs',
    checklist: 'checklist',
})

// Base class for custom nav section
class CustomNavSection {
    constructor(type) {
        // Section type: 'empty', 'tabs', 'checklist'
        this.type = type
        //
        this.lines = new Object()
    }

    get getType() { return this.type }

	get linesArray() { 
        return Object.values(this.lines)
    }

    get collections() {
        return Object.values(this.lines)
            .map((line) => line.collection)
            .filter((value, index, array) => array.indexOf(value) === index)
    }

    // get navLines() {
    //     return Array.from(Object.values(this.lines))
    // }

    addLine(id, name, collection, isChecked, onToggle, meta) {
        console.error('Abstract method "addLine" not implemented ', id, name, collection, isChecked, onToggle, meta)
    }

    getLine(id) {
        if (this.lines[id]) {
            return this.lines[id]
        } else {
            return null
        }
    }

    toggleLine(id) {
        console.error('Abstract method "toggleLine" not implemented ', id)
    }

    clean() {
        for (var line in this.lines) {
            delete this.lines[line]
        }
    }
}


// Empty nav section
export class EmptyNavSection extends CustomNavSection {
    constructor() {
        super(SECTION_TYPES.empty);
    }
}

// Checklist nav section
export class CustomNavChecklist extends CustomNavSection {
    constructor() {
        super(SECTION_TYPES.checklist)
    }

	// eventHandler prototype: (state) => {}
    // takes state (boolean) of checkbox on input.
	// TODO: refactoring https://habr.com/ru/articles/86403/
    addLine(id, name, collection, isChecked, eventHandler, meta) {
        const line = {
			id: id,
			name: name,
            collection: collection,
			isChecked: isChecked,
			eventHandler: eventHandler === undefined ? 
				() => { isChecked = !isChecked; } :
				() => { eventHandler(this.lines[id].isChecked); },
            meta: meta,
		}
		//console.log(onToggle, line)
        this.lines[id] = line
    }
}




// Tabs nav section
export class CustomNavTabs extends CustomNavSection {
    constructor() {
        super(SECTION_TYPES.tabs)
    }

    //
	addLine(id, name, collection, isChecked, eventHandler, meta) {
		const line = {
			id: id,
			name: name,
            collection: collection,
			isChecked: isChecked,
			eventHandler: eventHandler == undefined ? 
				() => {
                    this.checkTab(id);
                } :	() => {
                    this.checkTab(id);
                    eventHandler(id, this.lines[id].isChecked); 
                },
            meta: meta,
		}
		
		//console.log(eventHandler, line)
		this.lines[id] = line
	}

	uncheckAll() {
		for (const line of Object.values(this.lines)) {
			line.isChecked = false;
		}
	}

    checkTab(id) {
        //console.log("Check tab ", id)
        if (Object.hasOwn(this.lines, 'id')) {
            this.uncheckAll()
            this.lines[id].isChecked = true;
        }
    }

	activeTab() {
        return Object.values(this.lines).filter(tab => tab.isChecked)[0]
	}
}